var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_10184224",
    clipPath: "url(#clip0_433_7467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.3125 36.875V10.9375C38.3125 9.5625 37.1875 8.4375 35.8125 8.4375H12C10.625 8.4375 9.5 9.5625 9.5 10.9375V36.875C9.5 38.25 10.625 39.375 12 39.375H35.8125C37.1875 39.375 38.3125 38.25 38.3125 36.875Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.625 35.375C6.4375 35.0625 5.625 33.9375 5.625 32.6875V7.3125C5.625 5.8125 6.875 4.5625 8.4375 4.5625H31.625C32.875 4.5625 34 5.4375 34.3125 6.5625",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.75029 31.5C2.56279 31.1875 1.75029 30.0625 1.75029 28.8125V3.4375C1.68779 1.875 2.93779 0.625 4.50029 0.625H27.6878C28.9378 0.625 30.0628 1.5 30.3753 2.625",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.334 30.25H20.334V35.3125H18.334V30.25Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.25 27.625H25.25V35.3125H23.25V27.625Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.167 31.625H30.167V35.3125H28.167V31.625Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.625 22.125L22.1875 19.6875",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M29.625 19L26.4375 22.125",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.5 19.3125C31.1904 19.3125 31.75 18.7529 31.75 18.0625C31.75 17.3721 31.1904 16.8125 30.5 16.8125C29.8096 16.8125 29.25 17.3721 29.25 18.0625C29.25 18.7529 29.8096 19.3125 30.5 19.3125Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.5625 24.3125C26.2529 24.3125 26.8125 23.7529 26.8125 23.0625C26.8125 22.3721 26.2529 21.8125 25.5625 21.8125C24.8721 21.8125 24.3125 22.3721 24.3125 23.0625C24.3125 23.7529 24.8721 24.3125 25.5625 24.3125Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.3125 20C22.0029 20 22.5625 19.4404 22.5625 18.75C22.5625 18.0596 22.0029 17.5 21.3125 17.5C20.6221 17.5 20.0625 18.0596 20.0625 18.75C20.0625 19.4404 20.6221 20 21.3125 20Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.3125 24C18.0029 24 18.5625 23.4404 18.5625 22.75C18.5625 22.0596 18.0029 21.5 17.3125 21.5C16.6221 21.5 16.0625 22.0596 16.0625 22.75C16.0625 23.4404 16.6221 24 17.3125 24Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.375 19.6875L18.1875 21.875",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_7467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualSummary);
export default __webpack_public_path__ + "static/media/annual-summary.2b56ade25a83d62955372e9de1c2d460.svg";
export { ForwardRef as ReactComponent };